<script>
  export default {
    name: 'nav-footer',
    components: {

    },
    filters: {

    },
    mixins: [],
    props: {

    },
    data() {
      return {
        menuList: [],
      }
    },
    computed: {

    },
    watch: {

    },
    created() {

    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<template>
  <footer class="nav-footer">
    <div class="inner">
      <div class="content">
        <p>
          <span>营业执照注册号：911101026835911282</span>
          <span> ICP备案号：<a href="https://beian.miit.gov.cn" style="color: #f5f92d;">粤ICP备2020100870号</a></span>
        </p>
        <p>保险销售许可：安途保险代理有限公司（保险代理业务许可证编号：0039022 ）中国保监会网销许可</p>
        <p>版权所有 © 2018 安途保险代理有限公司</p>
      </div>
      <div class="logo text-hide">
        <a href="index.html">安途保险代理<img src="//media.winbaoxian.com/autoUpload/common/ft-logo_5ff5f91fb1dd5b2.png" title="安途保险代理"></a>
      </div>
    </div>
  </footer>
</template>

<style scoped>
  @import 'variable';

  .nav-footer {
    background-color: #de5b00;
    .inner {
      margin: 0 auto;
      padding: 0 20px;
      width: 1200px;
      height: 120px;
    }
    .content {
      float: left;
      width: 700px;
      padding-top: 25px;
      font-size: 14px;
      line-height: 1.7;
      color: #fff;
      span {
        /*margin-left: 20px;*/
      }
      a {
        color: #fff;
        &:hover {
          text-decoration: underline;
        }
      }
    }
    .logo {
      float: right;
      width: 300px;
      height: 56px;
      margin-top: 32px;
    }
  }
</style>
